import { action, computed } from 'mobx';

import { AppManager, Variables, Input } from 'core';

import { ThreadQuery, ThreadMutation, PinMutation } from 'apps/forum/gql';
import { ThreadModel, ThreadApp } from 'apps/forum/app';

export class ThreadAppManager extends AppManager {
  static registryName = 'ThreadAppManager';
  constructor(parent, init = {}) {
    super(parent, init);
    this.AppRef('threadPage', ThreadApp);
    this.variables = new Variables({
      urlId: () =>
        this.preview ? this.params.get('thread') : this.params.get('threadId'),
    });
    this.input = new Input({
      id: () => this.threadPage.id,
      title: () => this.threadPage.title,
      msg: () => this.threadPage.msg,
      categoryId: () => this.threadPage.categoryId,
      tags: () =>
        this.threadPage.tags.map(({ id, name, deleted }) => ({
          id,
          name,
          deleted,
        })),
    });
    this.variables.onChange(['urlId'], this.NewThreadId);
  }

  @computed
  get loading() {
    return this.queries.get('threadPage')?.loading;
  }

  @action
  NewThreadId = () => {
    if (this.variables.urlId) {
      const q = new ThreadQuery(this, {
        queryKey: 'threadPage',
        onSysErr: this.onSysErr,
      });
      q.process(
        threadPage => ThreadModel.Load(threadPage),
        this.ThreadPageUpdate,
      );
      q.query();
    }
  };

  @action
  ThreadPageUpdate = threadModel => {
    if (threadModel) {
      this.threadPage = threadModel;
    }
  };

  @action
  onSysErr = () => {
    // TODO
  };

  @action
  UpdateThread = options => {
    this.mutations.push(ThreadMutation.New(this.input, options));
  };

  @action
  DeleteThread = (input, options) => {
    this.mutations.push(ThreadMutation.New(input, options));
  };

  @action
  PinThread = (input, options) => {
    this.mutations.push(PinMutation.New(input, options));
  };
}
